/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Keen_Owl_PickInputs */

const en_calm_keen_owl_pick = /** @type {(inputs: Calm_Keen_Owl_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

const de_calm_keen_owl_pick = /** @type {(inputs: Calm_Keen_Owl_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum wählen`)
};

/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Calm_Keen_Owl_PickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_keen_owl_pick = /** @type {((inputs?: Calm_Keen_Owl_PickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Keen_Owl_PickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_keen_owl_pick(inputs)
	return de_calm_keen_owl_pick(inputs)
});